import { ReactElement } from 'react';

import { Location } from '@dreryk/egabinet-waitlist-frontend-api';

import { StrongText } from '@dreryk/react-components';
import { addressFormatter, Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { StyledServiceProvidingLocationCell } from './ServiceProvidingLocationCell.styled';

type ServiceProvidingLocationCellProps = {
   location: Location | undefined;
   videoConsultation: boolean;
   important: boolean;
};

export const ServiceProvidingLocationCell = (props: ServiceProvidingLocationCellProps): ReactElement => {
   return (
      <StyledServiceProvidingLocationCell direction={'column'} $important={props.important} width={'100%'}>
         {props.videoConsultation && !props.location ? (
            <Translate>{translationKeys.anyLocation}</Translate>
         ) : (
            <>
               <StrongText testId={'locationName'}>{props.location!.name}</StrongText>
               <span>{addressFormatter(props.location!.address)}</span>
            </>
         )}
      </StyledServiceProvidingLocationCell>
   );
};
